/**
 * Handle navbar state changes on scroll
 */
export const handleScroll = () => {
    const navbar = document.querySelector('.navbar');
    if (!navbar) return; // Safely exit if navbar doesn't exist
    
    if (window.scrollY > 50) {
        navbar.classList.add('scrolled');
    } else {
        navbar.classList.remove('scrolled');
    }
};
